export default {
    indexes: [],
    loading: false,
    incident: {},
    incidents: [],
    error: {},
    lastmodified: [],
    lastmodifiedbyuser: [],
}